export const executeWithDoublingTime = (fn: () => void, initialDelay: number) => {
  let delay = initialDelay
  let timeoutId: ReturnType<typeof setTimeout>

  const executeFunction = () => {
    fn()
    delay *= 2
    timeoutId = setTimeout(executeFunction, delay)
  }

  timeoutId = setTimeout(executeFunction, delay)

  return () => {
    window.clearTimeout(timeoutId)
  }
}

export function wait(ms: number = 0): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
